/* global FavoritesEnabled, */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';
import Dotdotdot from 'react-dotdotdot';
import Badge from 'components/Badge';
import Icon from 'components/Icon';
import Favorite, {
  FAVORITE_TYPE_ICON,
  FAVORITE_TEXT_POSITION_RIGHT,
  FAVORITE_PLUS_CIRCLE,
} from 'components/Favorite';
import StringList from 'components/StringList';
import ReadMore from 'components/ReadMore';
import { noop } from 'helpers/GlobalHelper';
import { SHOW_STATE_LIVE, SHOW_STATE_UPNEXT } from 'helpers/BadgeHelper';
import { PageNames, SegmentSources, tealiumEventPageTypes } from '@foxcorp/delta-web-analytics';
import { isMovie, castProcessor, videoIsTrailer } from 'helpers/ContentHelper';
import { helperGetSeriesDetailUrl } from 'helpers/RouteHelper';
import favoriteTheme from './Favorite.css';
import readMoreTheme from './ReadMore.css';
import Style from './VideoDetail.module.scss';

class VideoDetailComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggleDetailStatus: false,
      showNetworkIcon: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showNetworkIcon } = nextProps;
    this.setState({ showNetworkIcon });
  }

  onToggleClick = () => {
    const { toggleDetailStatus } = this.state;
    this.setState({ toggleDetailStatus: !toggleDetailStatus });
  };

  handleHover = hover => {
    const { setPlayerDataHover } = this.props;
    if (setPlayerDataHover) setPlayerDataHover(hover);
  };

  renderCreditsTags({ minimal }) {
    const { videoPage_castLabel: castLabel } = window.Language;
    const { actors: actorsRaw } = this.props;
    const uniqueByCharacterName = _.uniqBy(actorsRaw, e => e.characterName);
    const actors = _.uniqBy(uniqueByCharacterName, e => e.name);
    if (!actors || !actors.length) return null;
    if (minimal) {
      return (
        <StringList
          label={castLabel}
          items={actors}
          processor={castProcessor}
          className={Style.creditsString}
        />
      );
    }
    return (
      <div className={Style.creditsWrapper}>
        <StringList
          label={castLabel}
          items={actors}
          processor={castProcessor}
          className={Style.subtextCredits}
        />
      </div>
    );
  }

  renderDescriptionItem() {
    const { description } = this.props;
    if (!description) return null;
    return (
      <ReadMore
        className={Style.descriptionWrapper}
        moreText="More"
        lessText="Less"
        lines={1}
        theme={readMoreTheme}
      >
        {description}
      </ReadMore>
    );
  }

  renderFavorite() {
    const {
      disableFavorite,
      favoritableItems,
      favoritesManager,
      itemType,
      network,
      recommendationId,
      seriesName,
      showCode: showID,
      video,
    } = this.props;
    if (!FavoritesEnabled || disableFavorite) return null;
    const categoryType = _.get(video, 'categoryType');
    const location = _.get(tealiumEventPageTypes, PageNames.FAVORITES_DETAIL);
    const isPersonality = categoryType && categoryType === 'personality';
    const source = SegmentSources.VOD;
    const type = FAVORITE_TYPE_ICON;
    const textPosition = FAVORITE_TEXT_POSITION_RIGHT;
    let defaultText;

    const favoriteData = {
      actionLocation: 'player',
      favoritableItems,
      location,
      networkId: network,
      recommendationId,
      seriesName,
      showType: itemType,
      favoriteType: isPersonality ? 'personality' : itemType,
      showID,
      source,
    };

    return (
      <Favorite
        manager={favoritesManager}
        data={favoriteData}
        type={type}
        textPosition={textPosition}
        theme={favoriteTheme}
        defaultText={defaultText}
        iconType={FAVORITE_PLUS_CIRCLE}
      />
    );
  }

  renderInfoDetail() {
    const { networkIcon, description, tuneIn } = this.props;
    const { videoPage_tuneinLabel: tuneInLabel } = window.Language;
    const { toggleDetailStatus } = this.state;
    let infoContainerClasses = classNames(Style.infoContainer, Style.hidden);
    if (toggleDetailStatus) {
      infoContainerClasses = Style.infoContainer;
    }
    const tuneInText = () => {
      if (tuneIn) {
        const formattedText = tuneIn[0].toUpperCase() + tuneIn.substr(1).toLowerCase();
        return `${formattedText} on`;
      }
      return tuneIn;
    };
    const creditsTags = this.renderCreditsTags({});
    const tuneInTags = tuneIn ? (
      <div className={Style.tuneInWrapper}>
        <span className={Style.subtitle}>{tuneInLabel}</span>
        <span className={Style.subtextTuneIn}>{tuneInText()}</span>
        <div className={Style.networkLogoDetail}>
          <img alt="Network Logo" src={networkIcon} />
        </div>
      </div>
    ) : null;
    const descriptionTags = description ? (
      <div className={Style.descriptionWrapper}>
        <span className={Style.subtext}>{description}</span>
      </div>
    ) : null;
    if (!tuneInTags && !descriptionTags && !creditsTags) return null;
    return (
      <div className={infoContainerClasses}>
        <div className={Style.infoCenter}>
          {descriptionTags}
          {creditsTags}
          {tuneInTags}
        </div>
      </div>
    );
  }

  renderVideoDetail() {
    const {
      adPlaying,
      badge,
      isContextPlayer,
      isLive,
      isModal,
      isSeriesDetailAvailable,
      metadata,
      onTitleClick,
      playerLoading,
      renderInfo,
      seriesScreenUrl,
      showCode,
      showControls,
      showSubtitle,
      title,
      type,
      video,
    } = this.props;

    const { toggleDetailStatus, showNetworkIcon } = this.state;
    let detailIconType = 'keyboard-arrow-down';
    let toggleClasses = Style.toggle;
    const isMovieType = isMovie(type);
    const movieSubtitle = this.renderCreditsTags({ minimal: true });
    const subtitleText = isMovieType ? movieSubtitle : showSubtitle;
    const hideSubtitle = toggleDetailStatus && isMovieType;
    const subtitleTag = subtitleText && !hideSubtitle && (
      <h2 className={Style.showSubtitle}>
        <Dotdotdot clamp={3}>{subtitleText}</Dotdotdot>
      </h2>
    );
    if (toggleDetailStatus) {
      detailIconType = 'keyboard-arrow-up';
      toggleClasses = classNames(toggleClasses, Style.toggleActive);
    }
    const infoDetailComponent =
      ((renderInfo && toggleDetailStatus) || isModal) && this.renderInfoDetail();
    const toggleTags = renderInfo && (
      <Link key="videoDetailToggleLink" onClick={this.onToggleClick} className={toggleClasses}>
        <Icon size="medium" color="grey" icon={detailIconType} theme={Style} />
      </Link>
    );
    const descriptionItem = !renderInfo && !isModal && this.renderDescriptionItem();
    const networkLogoContainerClasses = [Style.logoContainer];
    if (!showNetworkIcon) networkLogoContainerClasses.push(Style.hideNetworkLogo);

    let badgeItem = null;
    if (badge) {
      const isTrailer = videoIsTrailer(video?.videoType, video?.clipType);
      const badgeLive = badge.toUpperCase() === SHOW_STATE_LIVE;
      const badgeInvalidUpNext = isLive && badge.toUpperCase() === SHOW_STATE_UPNEXT;
      if (!badgeLive && !badgeInvalidUpNext && video && !isTrailer) {
        badgeItem = <Badge theme={Style} badge={badge} />;
      }
    }
    const liveIndicator = isLive && <Badge theme={Style} badge={SHOW_STATE_LIVE} liveIndicator />;
    const badgeContainer = (badgeItem || liveIndicator) && (
      <div className={Style.badgeContainer}>
        {badgeItem}
        {liveIndicator}
      </div>
    );
    const containerClasses = [Style.container];
    const url = helperGetSeriesDetailUrl(showCode);
    let titleTag = isSeriesDetailAvailable ? (
      <Link onClick={onTitleClick} to={url} className={Style.titleLink}>
        {title}
      </Link>
    ) : (
      <span className={classNames(Style.titleLink, Style.titleLinkDisabled)}>{title}</span>
    );
    let titleClasses = Style.title;
    if (!seriesScreenUrl) {
      titleTag = title;
      titleClasses = classNames(Style.title, Style.titleDisabled);
    }
    if (isContextPlayer) {
      titleClasses = classNames(Style.title, Style.contextTitle);
    }
    if (!showControls) containerClasses.push(Style.controlsHidden);
    if (playerLoading) containerClasses.push(Style.playerLoading);
    if (adPlaying) containerClasses.push(Style.adPlaying);

    return (
      <div
        className={classNames(containerClasses)}
        onMouseEnter={() => this.handleHover(true)}
        onMouseLeave={() => this.handleHover(false)}
      >
        <div className={Style.detailContainer}>
          {badgeContainer}
          <div className={Style.titleHeader}>
            <aside className={titleClasses}>
              <div>
                {titleTag} {this.renderFavorite()}
              </div>
              {toggleTags}
              {subtitleTag}
              {descriptionItem}
              <p className={Style.metadata}>{metadata}</p>
            </aside>
          </div>
          {infoDetailComponent}
        </div>
      </div>
    );
  }

  render() {
    return this.renderVideoDetail();
  }
}

VideoDetailComponent.defaultProps = {
  actors: null,
  adPlaying: false,
  badge: null,
  description: null,
  disableFavorite: false,
  favoritableItems: [],
  favoritesManager: null,
  isContextPlayer: false,
  isLive: false,
  isModal: false,
  isSeriesDetailAvailable: true,
  itemType: null,
  metadata: null,
  network: null,
  networkIcon: null,
  onTitleClick: noop,
  playerLoading: false,
  recommendationId: null,
  renderInfo: false,
  seriesName: '',
  seriesScreenUrl: null,
  setPlayerDataHover: noop,
  showCode: '',
  showControls: false,
  showNetworkIcon: false,
  showSubtitle: null,
  title: '',
  tuneIn: null,
  type: '',
  video: null,
};

VideoDetailComponent.propTypes = {
  actors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  adPlaying: PropTypes.bool,
  badge: PropTypes.string,
  description: PropTypes.string,
  disableFavorite: PropTypes.bool,
  favoritableItems: PropTypes.arrayOf(PropTypes.shape({})),
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setFavorites: PropTypes.func.isRequired,
    deleteFavorites: PropTypes.func.isRequired,
  }),
  itemType: PropTypes.string,
  isContextPlayer: PropTypes.bool,
  isLive: PropTypes.bool,
  isModal: PropTypes.bool,
  isSeriesDetailAvailable: PropTypes.bool,
  metadata: PropTypes.string,
  network: PropTypes.string,
  networkIcon: PropTypes.string,
  onTitleClick: PropTypes.func,
  playerLoading: PropTypes.bool,
  recommendationId: PropTypes.string,
  renderInfo: PropTypes.bool,
  seriesName: PropTypes.string,
  seriesScreenUrl: PropTypes.string,
  setPlayerDataHover: PropTypes.func,
  showCode: PropTypes.string,
  showControls: PropTypes.bool,
  showNetworkIcon: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  showSubtitle: PropTypes.string,
  title: PropTypes.string,
  tuneIn: PropTypes.string,
  type: PropTypes.string,
  video: PropTypes.shape({}),
};

export default connect()(VideoDetailComponent);
